var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "#ADA7C1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5135 24.9377C31.0272 24.9377 32.2542 26.1647 32.2542 27.6785V28.3798C32.2542 29.4697 31.8647 30.5237 31.156 31.3517C29.2433 33.5863 26.334 34.689 22.5006 34.689C18.6665 34.689 15.7586 33.5859 13.8497 31.3504C13.1431 30.5229 12.7549 29.4706 12.7549 28.3825V27.6785C12.7549 26.1647 13.982 24.9377 15.4957 24.9377H29.5135ZM29.5135 26.7658H15.4957C14.9916 26.7658 14.583 27.1744 14.583 27.6785V28.3825C14.583 29.0353 14.8159 29.6668 15.2399 30.1632C16.7673 31.9519 19.1633 32.8609 22.5006 32.8609C25.8379 32.8609 28.2359 31.9519 29.7673 30.1629C30.1925 29.666 30.4261 29.0336 30.4261 28.3798V27.6785C30.4261 27.1744 30.0175 26.7658 29.5135 26.7658ZM22.5006 10.3184C25.866 10.3184 28.5943 13.0466 28.5943 16.4121C28.5943 19.7776 25.866 22.5059 22.5006 22.5059C19.1351 22.5059 16.4068 19.7776 16.4068 16.4121C16.4068 13.0466 19.1351 10.3184 22.5006 10.3184ZM22.5006 12.1465C20.1447 12.1465 18.2349 14.0563 18.2349 16.4121C18.2349 18.768 20.1447 20.6778 22.5006 20.6778C24.8564 20.6778 26.7662 18.768 26.7662 16.4121C26.7662 14.0563 24.8564 12.1465 22.5006 12.1465Z",
    fill: "#1F1D28"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileActive);
export default __webpack_public_path__ + "static/media/profile-active.aaebcd961d0582564cc20482ece80389.svg";
export { ForwardRef as ReactComponent };